import { Component, ContentChild, Input, TemplateRef, ElementRef, AfterViewInit, OnDestroy, HostListener } from '@angular/core';
import { DomainLookup } from 'src/app/model/interfaces/DomainLookup.interface';

@Component({
    selector: 'app-subdomain-navigation',
    templateUrl: './subdomain-navigation.component.html',
    styleUrls: ['./subdomain-navigation.component.scss']
})
export class SubdomainNavigationComponent implements AfterViewInit, OnDestroy {
    @Input() domain?: DomainLookup;

    @ContentChild(TemplateRef) itemTemplate: TemplateRef<any> | null = null;

    private resizeTimeout: any;

    constructor(private elementRef: ElementRef) { }

    ngAfterViewInit(): void {
        // Initial alignment
        this.alignHeaders();
    }

    ngOnDestroy(): void {
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
    }

    @HostListener('window:resize')
    onResize(): void {
        // Debounce resize events to avoid excessive recalculations
        if (this.resizeTimeout) {
            clearTimeout(this.resizeTimeout);
        }
        this.resizeTimeout = setTimeout(() => {
            this.alignHeaders();
        }, 150);
    }

    private alignHeaders(): void {
        // Use setTimeout to ensure this runs after Angular's change detection
        setTimeout(() => {
            const allHeaders = document.querySelectorAll('.subdomain-navigation-container .card-header');

            if (allHeaders.length === 0) return;

            // First, reset heights to auto to measure natural height
            allHeaders.forEach(header => {
                (header as HTMLElement).style.height = 'auto';
            });

            // Find the maximum natural height
            let maxHeight = 0;
            allHeaders.forEach(header => {
                const height = (header as HTMLElement).offsetHeight;
                if (height > maxHeight) {
                    maxHeight = height;
                }
            });

            // Apply the maximum height to all headers
            allHeaders.forEach(header => {
                (header as HTMLElement).style.height = `${maxHeight}px`;
            });
        }, 0);
    }

    getTitleSizeClass(label: string | undefined): string {
        const length = label?.length ?? 0;

        if (length > 40) return 'title-xs';
        if (length > 30) return 'title-sm';
        if (length > 20) return 'title-md';
        return 'title-lg';
    }
}
